var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 173,
    viewBox: "0 0 241 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210.852 53.2263V141.718C210.852 143.078 209.784 144.147 208.424 144.147H36.4286C35.0686 144.147 34 143.078 34 141.718V24.1823C34 22.8224 35.0686 21.7539 36.4286 21.7539H179.377L206.627 49.0008L210.852 53.2263Z",
    fill: "#1CD44F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M105.548 95.7284H51.0009C49.6409 95.7284 48.5723 94.6599 48.5723 93.3V38.7574C48.5723 37.3975 49.6409 36.329 51.0009 36.329H105.548C106.908 36.329 107.976 37.3975 107.976 38.7574V93.3C107.976 94.6599 106.908 95.7284 105.548 95.7284Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3774 45.504C48.3774 45.504 64.9406 32.6818 64.9406 21.7539H48.0859L48.3774 45.504Z",
    fill: "url(#paint0_linear_21_1372)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2988 65.5637C83.6908 65.5637 88.0619 61.193 88.0619 55.8014C88.0619 50.4098 83.6908 46.0391 78.2988 46.0391C72.9068 46.0391 68.5358 50.4098 68.5358 55.8014C68.5358 61.193 72.9068 65.5637 78.2988 65.5637Z",
    fill: "#052A37"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M84.7107 69.9837H71.839C67.4675 69.9837 63.4846 72.315 61.2988 76.0548C60.5702 77.3176 60.1816 78.7746 60.1816 80.2803V86.06H96.4653V80.2803C96.4653 78.7746 96.0767 77.3176 95.3481 76.0548C93.1138 72.2665 89.0823 69.9837 84.7107 69.9837Z",
    fill: "#052A37"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M192.687 130.114H51.0009C49.6409 130.114 48.5723 129.046 48.5723 127.686V110.104C48.5723 108.744 49.6409 107.676 51.0009 107.676H192.687C194.047 107.676 195.115 108.744 195.115 110.104V127.686C195.115 128.997 194.047 130.114 192.687 130.114Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M197.01 124.331C197.01 124.331 184.916 130.694 181.418 144.147H196.67L197.01 124.331Z",
    fill: "url(#paint1_linear_21_1372)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.873 45.7231H119.392V45.2852H194.873V45.7231Z",
    fill: "#052A37"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.872 59.4184H119.391V58.9805H194.872V59.4184Z",
    fill: "#052A37"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.872 73.117H119.391V72.679H194.872V73.117Z",
    fill: "#052A37"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M174.618 86.7622H119.391V86.3242H174.618V86.7622Z",
    fill: "#052A37"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M210.854 53.2264H181.808C180.447 53.2264 179.379 52.1579 179.379 50.7979V21.7539L210.854 53.2264Z",
    fill: "#146623"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M188.558 124.042V113.745C188.558 113.405 188.169 113.162 187.878 113.308L177.58 118.456C177.24 118.651 177.24 119.136 177.58 119.331L187.878 124.479C188.218 124.624 188.558 124.382 188.558 124.042Z",
    fill: "#1CD44F"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M181.855 53.2305L210.853 60.6615V53.2305H181.855Z",
    fill: "url(#paint2_linear_21_1372)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5124 6.99384C40.1694 6.99384 34.9236 5.34253 30.5521 2.28272L27.2977 0L24.0434 2.28272C19.6719 5.34253 14.426 6.99384 9.08306 6.99384H0V27.004C0 37.0577 4.95439 46.4314 13.2603 52.1139L27.3463 61.7305L41.4323 52.1139C49.7382 46.48 54.6926 37.0577 54.6926 27.004V6.99384H45.5124Z",
    fill: "#E5E5E5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.205 21.0261L22.3431 40.8864L10.7871 29.3313L13.1101 27.0084L22.3431 36.2406L39.882 18.7031L42.205 21.0261Z",
    fill: "#139BA5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M213.281 172.268C228.089 172.268 240.093 160.265 240.093 145.458C240.093 130.652 228.089 118.648 213.281 118.648C198.473 118.648 186.469 130.652 186.469 145.458C186.469 160.265 198.473 172.268 213.281 172.268Z",
    fill: "#FC7814"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M226.055 141.478H217.263V132.688H209.297V141.478H200.506V149.444H209.297V158.235H217.263V149.444H226.055V141.478Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_21_1372",
    x1: 53.7544,
    y1: 33.6303,
    x2: 68.2533,
    y2: 33.6303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18BCD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0122654,
    stopColor: "#18BCD2",
    stopOpacity: 0.9877
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18BCD2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_21_1372",
    x1: 181.409,
    y1: 134.239,
    x2: 197.001,
    y2: 134.239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18BCD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0122654,
    stopColor: "#18BCD2",
    stopOpacity: 0.9877
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18BCD2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_21_1372",
    x1: 192.669,
    y1: 56.9325,
    x2: 211.135,
    y2: 56.9325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18BCD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0122654,
    stopColor: "#18BCD2",
    stopOpacity: 0.9877
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#18BCD2",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgHome);
export default __webpack_public_path__ + "static/media/imgHome@.51dbe716c3c69e35d527a8ca88f99dff.svg";
export { ForwardRef as ReactComponent };